import {
    DossierDetailType,
    DossierStatusEnum,
    EstablishmentCategory,
    EstablishmentStatus,
    InstitutionalAffiliationType,
    OverViewDossierType,
    dossierStatusColorsType,
    establishementStatusEnum,
} from "../../../../types";
import { Box, Typography } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import OverViewDossier from "./OverViewDossier";
import Dossier from "../Dossier";
import { useContext } from "react";
import { LayoutBarContext } from "../../../../contexts";
import { dateFormat } from "../../../../consts";
import { getInstructorReview } from "./utils";
import { formatDate } from "../../../../lib";
import CustomChip from "../../../UIElements/CustomChip";

type OverViewDossierInstructorProps = {
    dossierDetail: DossierDetailType;
    linearProgressValue: number;
    _dossierStatusColors: dossierStatusColorsType;
    downloadCertificate?: Function;
    showDownloadCertificateBtn?: boolean;
    validatorDecision?: EstablishmentStatus;
    establishmentGroup: EstablishmentCategory | null;
    disablePaymentBtn?: boolean;
    isPayed?: boolean;
    institutionalAffiliation?: InstitutionalAffiliationType;
};

export default function OverViewDossierInstructor({
    dossierDetail,
    _dossierStatusColors,
    downloadCertificate,
    showDownloadCertificateBtn,
    validatorDecision,
    establishmentGroup,
    disablePaymentBtn,
    isPayed,
    institutionalAffiliation,
}: OverViewDossierInstructorProps) {
    const { updateContent } = useContext(LayoutBarContext);

    const instructorReview = getInstructorReview(dossierDetail);

    const overViewValidatorDossierInfos = {
        instructor: {
            processedAt: formatDate(dossierDetail?.processedAt, dateFormat),
        },
        validator: {
            user: dossierDetail.assignedValidatorUser,
        },
    };

    const validatorUser = overViewValidatorDossierInfos.validator?.user;

    const validatorName: string = validatorUser
        ? validatorUser.firstName + " " + validatorUser.lastName
        : "";

    const isDossierExaminated =
        dossierDetail.dossierStatus.code === DossierStatusEnum.FINALISE;

    // ########## instructSpace : overview dossier infos to instruct
    const buildOverviewDossierInfosToInstruct = (
        dossierDetail: DossierDetailType
    ): OverViewDossierType => {
        return {
            alertText: "",
            status: dossierDetail.dossierStatus.label,
            statusCode: dossierDetail.dossierStatus.code,
            _dossierStatusColors,
            subTitle: `Dossier de qualification pour ${dossierDetail.referenciel.name}`,
            title: dossierDetail.establishment.companyName,
            dossierId: dossierDetail?.id,
            showDownloadCertificateBtn,
            disablePaymentBtn,
            isPayed,
            institutionalAffiliation,
            content: (
                <>
                    {overViewValidatorDossierInfos ? (
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                    alignSelf: "stretch",
                                    flex: "1 0 0",
                                }}
                            >
                                <CustomChip
                                    sx={{
                                        display: "flex",
                                        height: "1.5rem",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "1.25rem",
                                        border: `1x solid #C8CDD0`,

                                        ".MuiChip-label": {
                                            color: "#023",
                                            textAlign: "center",
                                            fontFamily: "Roboto",
                                            fontSize: "0.75rem",
                                            fontStyle: "normal",
                                            fontWeight: "500",
                                            lineHeight: "normal",
                                        },
                                    }}
                                    label={
                                        establishmentGroup
                                            ? establishmentGroup.name
                                            : ""
                                    }
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    // flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    alignSelf: "stretch",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Transmis le
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>
                                            {
                                                overViewValidatorDossierInfos
                                                    .instructor.processedAt
                                            }
                                        </b>
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Avis instructeur
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{instructorReview}</b>
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    // flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    alignSelf: "stretch",
                                }}
                            >
                                {validatorName ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "0.5rem",
                                            alignSelf: "stretch",
                                            flex: "1 0 0",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "0.875rem",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            Examen
                                        </Typography>
                                        <Typography
                                            variant="h1"
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "1rem",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            <b>
                                                {validatorName
                                                    ? validatorName
                                                    : ""}
                                            </b>
                                        </Typography>
                                    </Box>
                                ) : null}
                                {validatorDecision &&
                                validatorDecision.code !==
                                    establishementStatusEnum.CANDIDAT ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "0.5rem",
                                            alignSelf: "stretch",
                                            flex: "1 0 0",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "0.875rem",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            Décision SYNERPA
                                        </Typography>
                                        <Typography
                                            variant="h1"
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "1rem",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            <b>{validatorDecision.label}</b>
                                        </Typography>
                                    </Box>
                                ) : null}
                            </Box>
                        </>
                    ) : null}
                </>
            ),
            actions: {
                edit: (
                    <CustomButton
                        onClick={() => {
                            if (dossierDetail.id) {
                                updateContent(
                                    <Dossier dossierId={dossierDetail.id} />
                                );
                            }
                        }}
                        label={
                            !isDossierExaminated
                                ? "Examiner le dossier"
                                : "Consulter le dossier"
                        }
                        customsx={{
                            width: "100%",
                        }}
                    />
                ),
                downloadCertificate,
            },
        };
    };

    return (
        <OverViewDossier
            overViewDossierInfo={buildOverviewDossierInfosToInstruct(
                dossierDetail
            )}
        />
    );
}
